import { DecimalPipe } from '@angular/common';
import type { PipeTransform } from '@angular/core';
import { Pipe, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import type { OnyxOptional } from '@onyx/angular';
import type { UnitRuleField } from '../constants/common/unit-rules';
import { UnitWarningHelper } from '../helpers/unit-warning.helper';

@Pipe({
  name: 'unitWarning',
})
export class UnitWarningPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);
  private readonly decimalPipe = inject(DecimalPipe);

  public transform(
    value: OnyxOptional<number>,
    field: UnitRuleField,
  ): string | null {
    const warning = UnitWarningHelper.getWarning(value, field);
    if (!warning) return null;

    const { key, suggestion } = warning;
    return this.translateService.instant(`unitWarnings.${key}`, {
      value:
        suggestion != null
          ? UnitWarningHelper.format(suggestion, field, this.decimalPipe)
          : null,
    });
  }
}
